export const DEFAULT_COLOR = '#0000ff';

export default {};
